import { UPLOAD_EXPERTS_STEPS_DEFAULTS } from "@/puck/defaults/uploadExpertsStepsDefaults";
import type { ColumnsBlockProps } from "@/puck/types";

type SlotBlock = {
  type: string;
  props: Record<string, unknown> & { id: string };
};

function numberedStepsBlock(id: string): SlotBlock {
  return {
    type: "NumberedSteps",
    props: {
      id,
      items: UPLOAD_EXPERTS_STEPS_DEFAULTS,
    },
  };
}

function gptPageMockupBlock(id: string): SlotBlock {
  return {
    type: "GptPageMockup",
    props: {
      id,
      greeting: "Coffee and Gail time?",
      inputPrompts: [
        { text: "Generate a COI for Riverside Logistics" },
        { text: "Summarize the loss runs for this account" },
        { text: "What changed on this policy at renewal?" },
        { text: "Draft an endorsement review for the added vehicle" },
      ],
      modelLabel: "Gail",
      searchPlaceholder: "Search...",
      suggestions: [
        {
          icon: "clipboard-list",
          title: "Review Claims",
          description: "Summarize claims with timeline and next steps",
        },
        {
          icon: "arrows-rotate",
          title: "Policy Renewal Review",
          description: "Compare expiring vs. renewal terms for changes",
        },
        {
          icon: "chart-line",
          title: "Loss Run Analysis",
          description: "Analyze loss runs for trends, ratios, and risk",
        },
        {
          icon: "file-lines",
          title: "Generate COI",
          description: "Create certificates of insurance from policy data",
        },
        {
          icon: "file-pen",
          title: "Endorsement Review",
          description: "Review endorsements for coverage changes and gaps",
        },
        {
          icon: "scale-balanced",
          title: "Compare Policies",
          description: "Compare coverage options across policies side by side",
        },
      ],
      zoom: "50",
    },
  };
}

function floatingBadgeBlock(id: string): SlotBlock {
  return {
    type: "FloatingBadge",
    props: {
      id,
      icon: "file-pdf",
      title: "UnderwritingGuide.pdf",
      status: "Indexed · ready to ask",
      angle: "-2",
      layout: "overlapping",
      align: "left",
      overlapMargin: 80,
    },
  };
}

/** Composed upload-experts section matching the GAIL-232 design. */
export function buildUploadExpertsSectionProps(
  id = "upload-experts-section",
): ColumnsBlockProps & { id: string } {
  return {
    id,
    columnCount: 2,
    showBorder: "none",
    eyebrow: "YOUR KNOWLEDGE, YOUR AI",
    title: "Build your own AI experts. <em>Just upload your documents.</em>",
    subtitle:
      "Drop in your guidelines, carrier appetites, SOPs, and forms. Gail turns them into an expert your whole team can ask.",
    headerAlign: "left",
    column1: [numberedStepsBlock("upload-experts-steps")] as ColumnsBlockProps["column1"],
    column2: [
      gptPageMockupBlock("upload-experts-mockup"),
      floatingBadgeBlock("upload-experts-badge"),
    ] as ColumnsBlockProps["column2"],
    column3: [],
    column4: [],
    column5: [],
    column6: [],
  };
}
